export default __webpack_public_path__ + "static/tdcc-23cba1acc1139fcf24f23305f97b36e6.png";